(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-steps-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const SECTION_SELECTOR = '.process-steps-grid';

    class ProcessStepsGrid {
      constructor(section) {
        this.section = section;
        this.initAnimation();
      }

      initAnimation() {
        if (!this.section.classList.contains('process-steps-grid--animate')) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
        );

        observer.observe(this.section);
      }
    }

    function initSections(root) {
      const scope = root || document;
      scope.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
        if (section.dataset.psgInitialized) return;
        section.dataset.psgInitialized = 'true';
        new ProcessStepsGrid(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSections());
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero-split"] && !Shopify.designMode) return;
  try {
    
  /**
   * Video Hero Split Section
   * Vanilla JS — no jQuery. Handles inline video playback,
   * parallax, animations, and accessibility.
   */
  (function () {
    const SECTION_SELECTOR = '.video-hero-split';

    class VideoHeroSplit {
      constructor(section) {
        this.section = section;
        this.videoType = section.dataset.videoType;
        this.playBtn = section.querySelector('[data-play-btn]');
        this.wrapper = section.querySelector('[data-video-wrapper]');
        this.thumbnail = section.querySelector('[data-thumbnail]');
        this.media = section.querySelector('[data-media]');
        this.video = section.querySelector('.video-hero-split__video');
        this.iframe = section.querySelector('.video-hero-split__iframe');
        this.playIcon = section.querySelector('[data-play-icon]');
        this.pauseIcon = section.querySelector('[data-pause-icon]');
        this.isPlaying = false;
        this.iframeReady = false;

        this.autoplay = section.dataset.autoplay === 'true';
        this.mute = section.dataset.mute === 'true';
        this.loop = section.dataset.loop === 'true';
        this.showControls = section.dataset.showControls === 'true';
        this.lazyLoad = section.dataset.lazyLoad === 'true';

        this.init();
      }

      init() {
        this.setAspectAuto();
        this.initAnimation();
        this.initParallax();
        this.bindEvents();

        if (this.autoplay && this.videoType !== 'none') {
          this.play();
        }
      }

      setAspectAuto() {
        if (!this.wrapper) return;
        const aspect = getComputedStyle(this.section).getPropertyValue('--vhs-aspect-ratio').trim();
        if (aspect === 'auto') {
          this.wrapper.setAttribute('data-aspect-auto', 'true');
        }
      }

      initAnimation() {
        if (!this.section.classList.contains('video-hero-split--animate')) return;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
        );

        observer.observe(this.section);
      }

      initParallax() {
        if (!this.section.classList.contains('video-hero-split--parallax')) return;

        const bgImage = this.section.querySelector('.video-hero-split__bg-image--parallax');
        if (!bgImage) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        let ticking = false;

        const updateParallax = () => {
          const rect = this.section.getBoundingClientRect();
          const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
          const offset = (scrollProgress - 0.5) * 40;
          bgImage.style.transform = `translate3d(0, ${offset}px, 0) scale(1.08)`;
          ticking = false;
        };

        const onScroll = () => {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        updateParallax();
      }

      bindEvents() {
        if (!this.playBtn) return;

        this.playBtn.addEventListener('click', () => this.toggle());

        this.playBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggle();
          }
        });

        if (this.video) {
          this.video.addEventListener('play', () => this.setPlayingState(true));
          this.video.addEventListener('pause', () => this.setPlayingState(false));
          this.video.addEventListener('ended', () => {
            if (!this.loop) this.setPlayingState(false);
          });
        }

        window.addEventListener('message', (e) => this.handleIframeMessage(e));
      }

      handleIframeMessage(event) {
        if (!this.iframe || event.source !== this.iframe.contentWindow) return;

        let data = event.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch { return; }
        }

        if (data.event === 'infoDelivery' && data.info) {
          if (typeof data.info.playerState !== 'undefined') {
            this.setPlayingState(data.info.playerState === 1);
          }
        }

        if (data.event === 'play') this.setPlayingState(true);
        if (data.event === 'pause') this.setPlayingState(false);
      }

      async toggle() {
        if (this.isPlaying) {
          this.pause();
        } else {
          await this.play();
        }
      }

      async play() {
        if (this.videoType === 'none') return;

        this.media?.removeAttribute('hidden');
        this.wrapper?.classList.add('is-playing');

        switch (this.videoType) {
          case 'shopify':
          case 'mp4':
            await this.playNative();
            break;
          case 'youtube':
            await this.playYouTube();
            break;
          case 'vimeo':
            await this.playVimeo();
            break;
        }
      }

      async playNative() {
        if (!this.video) return;

        if (this.lazyLoad && this.video.dataset.src && !this.video.src) {
          this.video.src = this.video.dataset.src;
          this.video.load();
        }

        if (this.mute) this.video.muted = true;

        try {
          await this.video.play();
          this.setPlayingState(true);
        } catch (err) {
          console.warn('Video Hero Split: playback failed', err);
        }
      }

      pauseNative() {
        if (!this.video) return;
        this.video.pause();
        this.setPlayingState(false);
      }

      async playYouTube() {
        if (!this.iframe) return;

        const videoId = this.iframe.dataset.youtubeId;
        if (!videoId) return;

        if (!this.iframe.src) {
          const params = new URLSearchParams({
            enablejsapi: '1',
            origin: window.location.origin,
            rel: '0',
            modestbranding: '1',
            playsinline: '1'
          });

          if (this.mute) params.set('mute', '1');
          if (this.loop) params.set('loop', '1');
          if (this.autoplay) params.set('autoplay', '1');

          this.iframe.src = `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
          this.iframeReady = true;
        }

        this.postYouTubeCommand('playVideo');
        this.setPlayingState(true);
      }

      pauseYouTube() {
        this.postYouTubeCommand('pauseVideo');
        this.setPlayingState(false);
      }

      postYouTubeCommand(func) {
        if (!this.iframe?.contentWindow) return;
        this.iframe.contentWindow.postMessage(
          JSON.stringify({ event: 'command', func, args: '' }),
          '*'
        );
      }

      async playVimeo() {
        if (!this.iframe) return;

        const videoId = this.iframe.dataset.vimeoId;
        if (!videoId) return;

        if (!this.iframe.src) {
          const params = new URLSearchParams({
            api: '1',
            player_id: `vhs-vimeo-${this.section.dataset.sectionId}`,
            title: '0',
            byline: '0',
            portrait: '0'
          });

          if (this.mute) params.set('muted', '1');
          if (this.loop) params.set('loop', '1');
          if (this.autoplay) params.set('autoplay', '1');

          this.iframe.src = `https://player.vimeo.com/video/${videoId}?${params.toString()}`;
          this.iframe.id = `vhs-vimeo-${this.section.dataset.sectionId}`;
          this.iframeReady = true;
        }

        this.postVimeoCommand('play');
        this.setPlayingState(true);
      }

      pauseVimeo() {
        this.postVimeoCommand('pause');
        this.setPlayingState(false);
      }

      postVimeoCommand(method) {
        if (!this.iframe?.contentWindow) return;
        this.iframe.contentWindow.postMessage(JSON.stringify({ method }), '*');
      }

      pause() {
        switch (this.videoType) {
          case 'shopify':
          case 'mp4':
            this.pauseNative();
            break;
          case 'youtube':
            this.pauseYouTube();
            break;
          case 'vimeo':
            this.pauseVimeo();
            break;
        }

        this.wrapper?.classList.add('is-paused');
      }

      setPlayingState(playing) {
        this.isPlaying = playing;
        this.wrapper?.classList.toggle('is-playing', playing);
        this.wrapper?.classList.toggle('is-paused', !playing);
        this.playBtn?.classList.toggle('is-playing', playing);
        this.playBtn?.setAttribute('aria-pressed', playing ? 'true' : 'false');
        this.playBtn?.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');

        if (this.playIcon) this.playIcon.hidden = playing;
        if (this.pauseIcon) this.pauseIcon.hidden = !playing;
      }
    }

    function initSections() {
      document.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
        if (section.dataset.vhsInitialized) return;
        section.dataset.vhsInitialized = 'true';
        new VideoHeroSplit(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSections);
    } else {
      initSections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector(SECTION_SELECTOR);
      if (section) {
        section.dataset.vhsInitialized = '';
        new VideoHeroSplit(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-test-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SECTION_SELECTOR = '.vtc';

    /* ── Helpers ── */
    function getYouTubeId(url) {
      if (!url) return null;
      var m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
      return m ? m[1] : null;
    }

    function getVimeoId(url) {
      if (!url) return null;
      var m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      return m ? m[1] : null;
    }

    /* ── Set play-button icon state ── */
    function setPlayBtnState(playBtn, playing) {
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      playBtn.setAttribute('aria-label',
        playing ? playBtn.getAttribute('aria-label').replace('Play', 'Pause') : playBtn.getAttribute('aria-label').replace('Pause', 'Play')
      );
      var playIcon  = playBtn.querySelector('.vtc__play-icon--play');
      var pauseIcon = playBtn.querySelector('.vtc__play-icon--pause');
      if (playIcon)  playIcon.style.display  = playing ? 'none'  : 'block';
      if (pauseIcon) pauseIcon.style.display = playing ? 'block' : 'none';
    }

    /* ══════════════════════════════════
       VideoTestCarousel constructor
    ══════════════════════════════════ */
    function VideoTestCarousel(section) {
      this.section   = section;
      this.track     = section.querySelector('[data-vtc-track]');
      this.prevBtn   = section.querySelector('[data-vtc-prev]');
      this.nextBtn   = section.querySelector('[data-vtc-next]');
      this.status    = section.querySelector('[data-vtc-status]');
      this.cards     = this.track
        ? Array.prototype.slice.call(this.track.querySelectorAll('.vtc__card'))
        : [];
      this.activeMedia        = null;
      this.announceTimer      = null;
      this.lastAnnouncedIndex = -1;

      this._bindNav();
      this._bindPlayButtons();
      this._bindKeyboard();
      this._bindVisibilityObserver();
      this._initAnimation();
    }

    /* ── Carousel scroll step ── */
    VideoTestCarousel.prototype._getStep = function () {
      if (!this.cards.length) return 0;
      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      return this.cards[0].getBoundingClientRect().width + gap;
    };

    /* ── Nav buttons ── */
    VideoTestCarousel.prototype._bindNav = function () {
      var self = this;
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function () {
          self.track.scrollBy({ left: -self._getStep(), behavior: 'smooth' });
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function () {
          self.track.scrollBy({ left: self._getStep(), behavior: 'smooth' });
        });
      }
      if (this.track) {
        var update = function () { self._updateNavState(); };
        this.track.addEventListener('scroll', function () {
          window.requestAnimationFrame(update);
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    };

    VideoTestCarousel.prototype._updateNavState = function () {
      if (!this.track) return;
      var maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      var atStart   = this.track.scrollLeft <= 0;
      var atEnd     = this.track.scrollLeft >= maxScroll;
      if (this.prevBtn) this.prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      if (this.nextBtn) this.nextBtn.setAttribute('aria-disabled', atEnd   ? 'true' : 'false');
    };

    /* ── Keyboard nav ── */
    VideoTestCarousel.prototype._bindKeyboard = function () {
      var self = this;
      if (!this.track) return;
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          self.track.scrollBy({ left: self._getStep(), behavior: 'smooth' });
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          self.track.scrollBy({ left: -self._getStep(), behavior: 'smooth' });
        }
      });
    };

    /* ── Stop any playing media ── */
    VideoTestCarousel.prototype._stopMedia = function (media) {
      if (!media) return;
      var type    = media.getAttribute('data-video-type');
      var playBtn = media.querySelector('[data-vtc-play]');

      if (type === 'shopify' || type === 'mp4') {
        var video = media.querySelector('[data-vtc-video]');
        if (video) { try { video.pause(); } catch (e) {} }

      } else {
        var iframe = media.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          try {
            if (type === 'youtube') {
              iframe.contentWindow.postMessage(
                JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), '*'
              );
            } else if (type === 'vimeo') {
              iframe.contentWindow.postMessage(
                JSON.stringify({ method: 'pause' }), '*'
              );
            }
          } catch (e) {}
        }
      }

      media.setAttribute('data-playing', 'false');
      setPlayBtnState(playBtn, false);
    };

    /* ── Play media ── */
    VideoTestCarousel.prototype._playMedia = function (media) {
      if (!media) return;

      var type    = media.getAttribute('data-video-type');
      var src     = media.getAttribute('data-video-src');
      var playBtn = media.querySelector('[data-vtc-play]');

      /* Stop currently playing card first */
      if (this.activeMedia && this.activeMedia !== media) {
        this._stopMedia(this.activeMedia);
      }

      /* ── Native video (Shopify / MP4) ── */
      if (type === 'shopify' || type === 'mp4') {
        var video = media.querySelector('[data-vtc-video]');
        if (!video) {
          console.warn('[VTC] No <video> element found in media container.');
          return;
        }
        if (!src) {
          console.warn('[VTC] No video src set on media container.');
          return;
        }

        /* Set src if not already loaded */
        var source = video.querySelector('source');
        if (source && !source.src) {
          source.src = src;
          video.load();
        }

        media.setAttribute('data-playing', 'true');
        setPlayBtnState(playBtn, true);

        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(function (err) {
            console.warn('[VTC] video.play() rejected:', err.message || err);
            /* Reset state if autoplay blocked */
            media.setAttribute('data-playing', 'false');
            setPlayBtnState(playBtn, false);
          });
        }

      /* ── YouTube ── */
      } else if (type === 'youtube') {
        var ytId = getYouTubeId(src);
        if (!ytId) { console.warn('[VTC] Could not extract YouTube ID from:', src); return; }

        var ytIframe = media.querySelector('iframe');
        if (!ytIframe) {
          ytIframe = document.createElement('iframe');
          ytIframe.src = 'https://www.youtube.com/embed/' + ytId
            + '?autoplay=1&playsinline=1&enablejsapi=1&rel=0';
          ytIframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          ytIframe.setAttribute('allowfullscreen', '');
          ytIframe.setAttribute('title', 'Test video player');
          ytIframe.style.zIndex = '2';
          media.appendChild(ytIframe);
        } else {
          try {
            ytIframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'playVideo', args: [] }), '*'
            );
          } catch (e) {}
        }
        media.setAttribute('data-playing', 'true');
        setPlayBtnState(playBtn, true);

      /* ── Vimeo ── */
      } else if (type === 'vimeo') {
        var vimeoId = getVimeoId(src);
        if (!vimeoId) { console.warn('[VTC] Could not extract Vimeo ID from:', src); return; }

        var vimeoIframe = media.querySelector('iframe');
        if (!vimeoIframe) {
          vimeoIframe = document.createElement('iframe');
          vimeoIframe.src = 'https://player.vimeo.com/video/' + vimeoId
            + '?autoplay=1&api=1&playsinline=1';
          vimeoIframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
          vimeoIframe.setAttribute('allowfullscreen', '');
          vimeoIframe.setAttribute('title', 'Test video player');
          vimeoIframe.style.zIndex = '2';
          media.appendChild(vimeoIframe);
        } else {
          try {
            vimeoIframe.contentWindow.postMessage(
              JSON.stringify({ method: 'play' }), '*'
            );
          } catch (e) {}
        }
        media.setAttribute('data-playing', 'true');
        setPlayBtnState(playBtn, true);
      }

      this.activeMedia = media;

      /*
        Remove focus from the play button once playback starts.
        On touch devices, tapping a button gives it focus, and that focus
        persists (no natural "blur" event). If we leave the button focused,
        any focus-based CSS reveal rule would keep it visible for the whole
        video, which is the bug being fixed here.
      */
      if (playBtn && document.activeElement === playBtn) {
        playBtn.blur();
      }
    };

    /* ── Wire up play buttons ── */
    VideoTestCarousel.prototype._bindPlayButtons = function () {
      var self     = this;
      var mediaEls = this.section.querySelectorAll('[data-vtc-media]');

      mediaEls.forEach(function (media) {
        var hasVideo = media.getAttribute('data-has-video') === 'true';
        var playBtn  = media.querySelector('[data-vtc-play]');

        /*
          Track real pointer hover with JS instead of relying on CSS :hover.
          `pointerenter`/`pointerleave` only fire for an actual mouse/pen
          hovering — touch taps do not trigger a lingering hover state, so
          this naturally solves the "stuck pause button" issue on mobile,
          while still showing the pause icon on hover on desktop.
        */
        media.addEventListener('pointerenter', function (e) {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
            media.classList.add('is-hovering');
          }
        });
        media.addEventListener('pointerleave', function (e) {
          if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
            media.classList.remove('is-hovering');
          }
        });

        /*
          Touch devices have no real "hover", so tapping the video reveals
          the pause button for a couple seconds (like YouTube/Instagram
          controls) instead of relying on a hover state that can never
          naturally trigger or clear on touch.
        */
        var touchRevealTimer = null;
        media.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'touch') return;
          media.classList.add('is-hovering');
          clearTimeout(touchRevealTimer);
          touchRevealTimer = setTimeout(function () {
            media.classList.remove('is-hovering');
          }, 2500);
        });

        /* Make the whole media area clickable too */
        media.addEventListener('click', function (e) {
          /* Only trigger if click wasn't on the play button itself (handled below) */
          if (e.target === playBtn || playBtn.contains(e.target)) return;
          if (!hasVideo) return;
          var isPlaying = media.getAttribute('data-playing') === 'true';
          if (isPlaying) {
            self._stopMedia(media);
            self.activeMedia = null;
          } else {
            self._playMedia(media);
          }
        });

        if (!playBtn) return;

        /* Play button click */
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!hasVideo) return;
          var isPlaying = media.getAttribute('data-playing') === 'true';
          if (isPlaying) {
            self._stopMedia(media);
            self.activeMedia = null;
          } else {
            self._playMedia(media);
          }
          /* Drop focus after the tap so it doesn't stay "active" on mobile */
          playBtn.blur();
        });

        /* Native video events */
        var video = media.querySelector('[data-vtc-video]');
        if (video) {
          video.addEventListener('pause', function () {
            if (media.getAttribute('data-playing') === 'true' && !video.ended) {
              media.setAttribute('data-playing', 'false');
              setPlayBtnState(playBtn, false);
            }
          });

          video.addEventListener('ended', function () {
            media.setAttribute('data-playing', 'false');
            setPlayBtnState(playBtn, false);
            video.currentTime = 0;
            media.classList.remove('is-hovering');
          });

          video.addEventListener('play', function () {
            media.setAttribute('data-playing', 'true');
            setPlayBtnState(playBtn, true);
          });
        }
      });
    };

    /* ── IntersectionObserver: announce card for screen readers ── */
    VideoTestCarousel.prototype._bindVisibilityObserver = function () {
      var self = this;
      if (!this.cards.length || !('IntersectionObserver' in window)) return;

      var observer = new IntersectionObserver(function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          }
        });
        if (!best) return;
        var index = self.cards.indexOf(best.target);
        if (index !== self.lastAnnouncedIndex) {
          self.lastAnnouncedIndex = index;
          clearTimeout(self.announceTimer);
          self.announceTimer = setTimeout(function () {
            if (!self.status) return;
            var nameEl = best.target.querySelector('.vtc__card-name');
            var name   = nameEl ? nameEl.textContent.trim() : '';
            self.status.textContent = 'Showing test ' + (index + 1) + ' of ' + self.cards.length
              + (name ? ': ' + name : '');
          }, 450);
        }
      }, { root: this.track, threshold: [0.6] });

      this.cards.forEach(function (card) { observer.observe(card); });
    };

    /* ── Scroll-reveal animation ── */
    VideoTestCarousel.prototype._initAnimation = function () {
      if (!this.section.classList.contains('vtc--animate')) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
      observer.observe(this.section);
    };

    /* ── Init all sections ── */
    function initSections(root) {
      var scope = root || document;
      scope.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
        if (section.dataset.vtcInitialized) return;
        section.dataset.vtcInitialized = 'true';
        new VideoTestCarousel(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initSections(); });
    } else {
      initSections();
    }

    /* Shopify theme editor live reload */
    document.addEventListener('shopify:section:load', function (event) {
      initSections(event.target);
    });

  })();

  } catch(e) { console.error(e); }
})();
})();
